import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { KeywordsTableWrapper } from "../styleComponents";
import type { ColumnGenerator, ITransformedEnrichedKeywordsData, ITransformedEnrichedPagesData } from "../types";

import type { IEnrichedTableProps } from "./EnrichedTable";
import { EnrichedTable } from "./EnrichedTable";

const borderStyle = `1px solid ${colorsPalettes.carbon[50]}`;

interface IEnrichedTabBaseProps<T> extends IEnrichedTableProps<T> {
    selectedPageTab: string;
    onLinkClick: () => void;
    getTableColumns: ColumnGenerator;
    bottomSection?: ReactNode;
    linkButtonTitle?: string;
    topTitle?: string;
    handleCloseExpandedRow: () => void;
}

export const EnrichedTabBase = <T extends ITransformedEnrichedKeywordsData | ITransformedEnrichedPagesData>({
    topTitle,
    onLinkClick,
    linkButtonTitle,
    bottomSection,
    handleCloseExpandedRow,
    ...tableProps
}: IEnrichedTabBaseProps<T>) => {
    return (
        <KeywordsTableWrapper>
            <Flex
                justifyContent="space-between"
                alignItems="center"
                padding="16px 24px"
                borderBottom={borderStyle}
            >
                {topTitle}
                {/* <IconButton
                    iconName="link-out"
                    onClick={onLinkClick}
                    type="flat"
                    placement="right"
                >
                    {linkButtonTitle}
                </IconButton> */}
                <IconButton
                    type="flat"
                    iconName="clear"
                    iconSize="xs"
                    onClick={handleCloseExpandedRow}
                />
            </Flex>
            <EnrichedTable {...tableProps} />
            {bottomSection ? (
                <Flex
                    alignItems="center"
                    justifyContent="flex-end"
                    padding="16px 24px"
                    borderTop={borderStyle}
                    margin="12px 0 0"
                >
                    {bottomSection}
                </Flex>
            ) : null}
        </KeywordsTableWrapper>
    );
};
